export enum FreelancerSignupContext {
    REGULAR = 'REGULAR',
    STRATEGY = 'STRATEGY',
    OPEN = 'OPEN',
}
